import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadRuntimeConfig } from './app/core/runtime-config';

// Config en runtime (Docker): se lee assets/config.json y se sobrescribe la URL del API
// ANTES de crear el inyector de Angular. Así TODOS los servicios —que capturan
// `environment.backUrlApi` en el inicializador de su campo, al construirse— leen ya el valor
// de runtime. Hacerlo como APP_INITIALIZER era una carrera: un servicio construido durante el
// arranque (p.ej. auth) capturaba el valor COMPILADO (environment.*.ts) antes de que el fetch
// async de config.json resolviera, y ese singleton quedaba con la URL equivocada toda la sesión.
// loadRuntimeConfig nunca lanza (fallback silencioso a environment), pero usamos finally para
// garantizar el arranque pase lo que pase.
loadRuntimeConfig().finally(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
